export default __webpack_public_path__ + "static/media/WEBINAR HALL-LABEL.49f3fdd7.png";